/* eslint-disable no-return-await */
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Form } from '@unform/web';
import flatten from '@turf/flatten';
import { Link, useHistory } from 'react-router-dom';
import {
  FiDownload,
  FiFilter,
  FiMap,
  FiUpload,
  FiEdit3,
  FiUsers,
} from 'react-icons/fi';
import Swal from 'sweetalert2';
import {
  FaArrowDown,
  FaChevronLeft,
  FaChevronRight,
  FaDownload,
  FaEllipsisH,
  FaLocationArrow,
} from 'react-icons/fa';
import { GiWheat } from 'react-icons/gi';
import shp from 'shpjs';
import Pagination from 'react-paginate';
import { kml } from '@tmcw/togeojson';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Card,
  Col,
  Row,
  Table,
  UncontrolledCollapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import { toast } from 'react-toastify';

import shpwrite from 'shp-write';
import CSVReader from 'react-csv-reader';
import { Input, Select, ReactSelectAsync } from '../../components/unform/index';
import api from '../../services/api';

import Safras from './Safras';
import Talhoes from './Talhoes';
import Croquis from './Croquis';

import { Translator } from '../../components/i18n';

import { useAuth } from '../../contexts/auth';

function Fazendas() {
  const { user } = useAuth();

  const obrigatorio = Translator({
    path: 'obrigatorio',
  });
  const erroBuscaDados = Translator({
    path: 'erroBuscaDados',
  });
  const dadosSalvosSucesso = Translator({
    path: 'dadosSalvosSucesso',
  });
  const erroSalvarDados = Translator({
    path: 'erroSalvarDados',
  });
  const erro = Translator({
    path: 'erro',
  });

  const croqui = Translator({
    path: 'fazenda.upload.croqui',
  });
  const mapaaplicacao = Translator({
    path: 'mapa.filtros.mapaaplicacao',
  });
  const mapafertilidade = Translator({
    path: 'mapa.filtros.mapafertilidade',
  });
  const pontos = Translator({
    path: 'pontos',
  });
  const naoSelecione = Translator({
    path: 'fazenda.upload.naoSelecione',
  });

  const ativo = Translator({
    path: 'fazenda.ativetalhoes.ativo',
  });
  const inativo = Translator({
    path: 'fazenda.ativetalhoes.inativo',
  });

  const formRef = useRef();
  const formRefSafra = useRef();
  const formRefFazenda = useRef();
  const formRefTalhoesDownload = useRef();

  const history = useHistory();

  const [fazendaData, setFazendaData] = useState(null);

  const [fazendas, setFazendas] = useState([]);
  const [filtro, setFiltro] = useState({});

  const [csvData, setCSVData] = useState(null);

  const [activeTab, setActiveTab] = useState('1');
  const [modal, setModal] = useState(false);
  const [modalImport, setModalImport] = useState(false);
  const [modalSafra, setModalSafra] = useState(false);
  const [modalSafrafazenda, setModalSafrafazenda] = useState(false);
  const [modalCad, setModalCad] = useState(false);
  const [modalSafraDowloadSHP, setModalSafraDowloadSHP] = useState(false);
  const [modalSafras, setModalSafras] = useState(false);
  const [modalDados, setModalDados] = useState(false);
  const [modalUsuarios, setModalUsuarios] = useState(false);
  const [modalTalhoes, setModalTalhoes] = useState(false);

  const [selectedFazenda, setSelectedFazenda] = useState({});
  const [selectedSafra, setSelectedSafra] = useState(null);
  const [safrasFazendaUpload, setSafrasFazendaUpload] = useState(null);
  const [safrasFazenda, setSafrasFazenda] = useState(null);
  const [fazendaId, setFazendaId] = useState(0);

  const [usuariosFazenda, setUsuariosFazenda] = useState([]);

  const [talhoesImportCR, setTalhoesImportCR] = useState([]);

  const [arquivosDownload, setArquivosDownload] = useState([]);
  const [modalArquivosDowload, setModalArquivosDowloasd] = useState(false);
  const toggleModalArquivosDownload = () =>
    setModalArquivosDowloasd(!modalArquivosDowload);

  const [origem, setOrigem] = useState('');

  const [talhoesSafra, setTalhoesSafra] = useState([]);

  // const [talhoesToEdit, setTalhoesToedit] = useState([]);

  const [tipoDowload, setTipoDowload] = useState('CR');

  const [geoJSON, setGeoJSON] = useState({});

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noreferrer');
  };

  const toggle = () => setModal(!modal);
  const toggleImport = () => setModalImport(!modalImport);
  const toggleSafra = () => setModalSafra(!modalSafra);
  const toggleModalCad = () => setModalCad(!modalCad);
  const toggleModalDados = () => setModalDados(!modalDados);
  const toggleModalSafras = () => setModalSafras(!modalSafras);
  const toggleSafrasFazenda = () => setModalSafrafazenda(!modalSafrafazenda);
  const toggleModalUsuarios = () => setModalUsuarios(!modalUsuarios);
  const toggleSafraDowloadSHP = () =>
    setModalSafraDowloadSHP(!modalSafraDowloadSHP);

  const toggleSelectTalhoes = () => setModalTalhoes(!modalTalhoes);
  // const toggleEditTalhoes = () => setModalEditTalhoes(!modalEditTalhoes);

  // async function filtrarConsultaAsyncCreate(inputValue) {
  //   const { data } = await api.get(`/cultura?descricao=${inputValue}`);

  //   return data.map((e) => ({ value: e.value, label: e.descricao }));
  // }

  async function filtrarConsultaAsync(inputValue) {
    const { data } = await api.get(`/produtor?nome=${inputValue}`);

    return data.map((e) => ({ id: e.id, value: e.id, label: e.nome }));
  }

  // async function handleAddCultura(descricao) {
  //   Swal.showLoading();
  //   try {
  //     const body = {
  //       descricao,
  //     };

  //     const { data } = await api.post('/cultura', body);

  //     const tipo = {
  //       value: data?.id,
  //       label: data?.descricao,
  //     };

  //     formRefSafra.current.setFieldValue('id_cultura', tipo);
  //     Swal.close();
  //   } catch (err) {
  //     toast.error(err?.response?.data?.error || 'Erro ao salvar!');
  //     Swal.close();
  //   }
  // }

  let selectOptions;
  // const optionsCulturas = async (inputValue) =>
  //   await new Promise((resolve) => {
  //     clearTimeout(selectOptions);

  //     selectOptions = setTimeout(() => {
  //       resolve(filtrarConsultaAsyncCreate(inputValue));
  //     }, 500);
  //   });

  const optionsProdutor = async (inputValue) =>
    await new Promise((resolve) => {
      clearTimeout(selectOptions);

      selectOptions = setTimeout(() => {
        resolve(filtrarConsultaAsync(inputValue));
      }, 500);
    });

  let timeoutConsulta;

  function filtrarConsulta(e, value) {
    setFiltro({ ...filtro, [value]: e, page: 1 });
  }

  const debounceConsulta = async (body, value) =>
    new Promise((resolve) => {
      clearTimeout(timeoutConsulta);

      timeoutConsulta = setTimeout(() => {
        resolve(filtrarConsulta(body, value));
      }, 1000);
    });

  async function getFazenda() {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const params = Object.keys(filtro)
      .map((e) => {
        if (e === 'page') {
          if (Number.isNaN(filtro[e])) {
            return `${e}=${1}`;
          }
        }
        return `${e}=${filtro[e]}`;
      })
      .join('&');

    const { data } = await api.get(`/fazendas?${params}`);

    setFazendas(data);
    window.scrollTo(0, 0);

    Swal.close();
  }

  useEffect(() => {
    getFazenda();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtro]);

  async function uploadDeArquivos(id) {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const { data } = await api.get(`/fazenda-upload/${id}`);

      setSelectedFazenda(data);
      const safras = [
        {
          label: 'Selecione',
          value: '',
        },
      ];

      if (data?.safras) {
        for (let index = 0; index < data?.safras?.length; index += 1) {
          const safra = data?.safras[index];

          safras.push({
            id: safra?.id,
            label: safra?.descricao,
            value: safra?.id,
          });
        }
      }

      setSafrasFazendaUpload(safras);

      toggle();
      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  }

  // async function criarSafra(id) {
  //   try {
  //     setFazendaId(id);
  //     toggleSafra();
  //     Swal.close();
  //   } catch (err) {
  //     toast.error('Erro ao buscar dados da fazenda!');
  //     Swal.close();
  //   }
  // }

  const handleSubmit = async (data) => {
    const errors = {};
    Object.keys(data).forEach((f) => {
      if (
        !data[f] &&
        f !== 'complemento' &&
        !['CSVA', 'CSVF', 'MA', 'MF'].includes(data.origem) &&
        f !== 'id_talhao' &&
        f !== 'talhao' &&
        f !== 'cep' &&
        !(data.origem === 'CR' && f === 'safra')
      ) {
        errors[f] = obrigatorio;
      }
    });

    formRef.current.setErrors(errors);
    if (!Object.keys(errors).length) {
      try {
        Swal.fire({
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        if (data?.origem !== 'T') {
          const obj = {
            id_fazenda: Number(selectedFazenda?.fazenda?.id),
            id_produtor: Number(selectedFazenda?.fazenda?.Produtor?.id),
            id_talhao: Number(data?.talhao) || null,
            id_safra: Number(data?.safra) || null,
            origem_: data?.origem,
            csvData,
            geoJSON,
          };
          const { data: response } = await api.post('/arquivo', obj);
          if (origem === 'CR') {
            toggleImport();

            setTalhoesImportCR(response?.array_ids);
          }
          if (
            origem !== 'CSVA' &&
            origem !== 'CSVF' &&
            data?.safra !== null &&
            origem !== 'T'
          ) {
            const formData = new FormData();
            formData.append('nome_arquivo', data.file.name);
            formData.append('file', data.file);
            formData.append('id_safra', Number(data?.safra) || null);
            formData.append('id_fazenda', Number(selectedFazenda?.fazenda?.id));
            formData.append('id_talhao', Number(data?.talhao) || null);
            formData.append('tipo', data?.origem);

            try {
              await api.post('/salvar-arquivo-mapa', formData);
            } catch (error) {
              Swal.close();
              toast.error(error?.response?.data?.error || erroSalvarDados);
            }
          }
        } else {
          const body = {
            id_fazenda: Number(selectedFazenda?.fazenda?.id),
            descricao: data?.descricao,
            geoJSON,
          };
          await api.post('/talhao', body);
        }

        toast.success(dadosSalvosSucesso);
        setOrigem('');
        setGeoJSON({});
        setCSVData(null);
        setSafrasFazenda(null);
        setSelectedSafra(null);
        setTalhoesSafra([]);
        toggle();
        Swal.close();
      } catch (err) {
        toast.error(err?.response?.data?.error || erroSalvarDados);
        Swal.close();
      }
    }
  };

  const handleSubmitSafra = async (data) => {
    const errors = {};

    Object.keys(data).forEach((f) => {
      if (!data[f]) {
        errors[f] = obrigatorio;
      }
    });

    formRefSafra.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        data.id_fazenda = fazendaId;
        await api.post('/safra', data);
        toast.success(dadosSalvosSucesso);
        toggleSafra();
        Swal.close();
      } catch (err) {
        toast.error(err?.response?.data?.error || erroSalvarDados);
        Swal.close();
      }
    }
  };

  const carregaSafras = async (id) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const { data } = await api.get(`/safras-fazenda/${id}`);

      setFazendaId(id);
      setSafrasFazenda(data);
      toggleSafrasFazenda();
      Swal.close();
    } catch (err) {
      toast.error(err?.response?.data?.error || erroSalvarDados);
      Swal.close();
    }
  };

  const handleCadFazenda = async (data) => {
    const errors = {};

    Object.keys(data).forEach((f) => {
      if (!data[f] && f !== 'complemento' && f !== 'cep') {
        errors[f] = obrigatorio;
      }
    });

    formRefFazenda.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        await api.post('/fazenda', data);
        toast.success(dadosSalvosSucesso);
        getFazenda();
        toggleModalCad();
        Swal.close();
      } catch (err) {
        toast.error(err?.response?.data?.error || erroSalvarDados);
        Swal.close();
      }
    }
  };

  const consultarCep = async (data) => {
    if (data) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        const { data: resultCep } = await axios.get(
          `https://brasilapi.com.br/api/cep/v2/${data}`
        );
        if (resultCep) {
          formRefFazenda.current.setFieldValue('logradouro', resultCep?.street);
          formRefFazenda.current.setFieldValue('estado', resultCep?.state);
          formRefFazenda.current.setFieldValue('cidade', resultCep?.city);
          formRefFazenda.current.setFieldValue(
            'bairro',
            resultCep?.neighborhood
          );
        }
        Swal.close();
      } catch (err) {
        formRefFazenda.current.setFieldValue('logradouro', '');
        formRefFazenda.current.setFieldValue('estado', '');
        formRefFazenda.current.setFieldValue('cidade', '');
        formRefFazenda.current.setFieldValue('bairro', '');
        toast.warning('CEP não encontrado!');
        Swal.close();
      }
    }
  };

  const getTalhoesSafra = async (idSafra) => {
    if (idSafra && origem !== 'CR') {
      try {
        const { data } = await api.get(`/safra-upload/${idSafra}`);

        setTalhoesSafra(data?.talhoes);
      } catch (err) {
        toast.error(erroBuscaDados);
      }
    }
  };

  const getTalhoesSafraID = async (id) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const { data } = await api.get(`/safra-upload/${id}?selecione=Todos`);
      setSelectedSafra(id);
      setTalhoesSafra(data?.talhoes);
      toggleSelectTalhoes();
      Swal.close();
    } catch (err) {
      Swal.close();
      toast.error(erroBuscaDados);
    }
  };

  const getArquivosDowload = async (safra, tipo) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const { data } = await api.get(`/novo-download/${safra}/${tipo}`);
      setArquivosDownload(data);
      toggleModalArquivosDownload();
      Swal.close();
    } catch (err) {
      Swal.close();
      toast.error(erroBuscaDados);
    }
  };

  async function handleDownload(bodyData) {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const body = {
        id_fazenda: fazendaId,
        id_safra: selectedSafra,
        id_talhao: bodyData.talhao,
        tipo: tipoDowload,
      };
      const { data } = await api.post('/shape-dowload-talhao', body);

      const merge = data?.mapaMongo.reduce((a, element) => {
        a = a.concat(
          flatten({
            type: 'FeatureCollection',
            features:
              tipoDowload === 'PC'
                ? element?.mapa?.objeto?.[0]?.features
                : element?.mapa?.objeto?.[0]?.features?.filter(
                    (f) => f?.geometry && f?.geometry?.type !== 'Point'
                  ),
          }).features
        );

        return a;
      }, []);

      const talhao = bodyData.talhao
        ? ` - Talhão: ${data.mapaMongo[0]?.talhao}`
        : '';

      const options = {
        folder: `${tipoDowload} - ${
          data?.fazendaCroqui?.nome_fazenda
        } - Safra: ${data?.fazendaCroqui?.nome_safra?.replace(
          '/',
          '-'
        )}${talhao}`,
        names: [],
        types: {
          point: 'Point',
          polygon: 'Polygon',
          line: 'Line',
        },
      };

      shpwrite.download(
        {
          type: 'FeatureCollection',
          features: merge,
        },
        options
      );

      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  }

  const dowloadShapeFileModal = async (id) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const { data } = await api.get(`/safras-fazenda/${id}`);

      setFazendaId(id);
      setSafrasFazenda(data);
      toggleSafraDowloadSHP();
      Swal.close();
    } catch (err) {
      toast.error(err?.response?.data?.error || erroSalvarDados);
      Swal.close();
    }
  };

  const dowloadShapeFile = async (idFazenda, idSafra) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const { data } = await api.get(`/shape-dowload/${idFazenda}/${idSafra}`);
      const options = {
        folder: `CR - ${data?.fazendaCroqui?.Fazenda?.nome} - Safra: ${data?.fazendaCroqui?.Safra?.descricao}`,
        names: [],
        types: {
          point: 'Point',
          polygon: 'Polygon',
          line: 'Line',
        },
      };
      shpwrite.download(flatten(data?.mapaMongo?.objeto[0]), options);
      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  };

  const dadosFazenda = async (id) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const { data } = await api.get(`/fazenda/${id}`);

      setFazendaData(data);
      toggleModalDados();
      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  };

  const handleEditFazenda = async (data) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      data.old_produtor = fazendaData?.fazenda?.Produtor?.id;
      await api.put(`/fazenda/${fazendaData?.fazenda?.id}`, data);

      getFazenda();
      setFazendaData(null);
      toggleModalDados();
      Swal.close();
    } catch (err) {
      toast.error(err?.response?.data?.error || erroSalvarDados);
      Swal.close();
    }
  };

  function formatCSVData(data) {
    if (data.length) {
      const arrayObject = [];
      if (data[0].length) {
        for (let index = 1; index < data.length; index += 1) {
          const element = data[index];
          const insideObj = {};
          for (let header = 0; header < data[0].length; header += 1) {
            const headerElement = data[0][header]?.toLowerCase();

            insideObj[headerElement] = element[header];
          }
          arrayObject.push(insideObj);
        }
      }

      setCSVData(arrayObject);
    }
  }

  async function getUsuariosVinculados(id) {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const { data } = await api.get(`/usuarios-fazenda/${id}`);
      setUsuariosFazenda(data);
      toggleModalUsuarios();
      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  }

  async function statusTalhaoSafra(idTalhao, idFazenda, status) {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const body = {
        id_talhao: idTalhao,
        id_fazenda: idFazenda,
        status,
      };

      await api.put('/ativa-safra-talhao', body);
      toast.success('Talhão ativado/inativado com sucesso!');
      Swal.close();
    } catch (err) {
      toast.error(erro);
      Swal.close();
    }
  }

  // useEffect(() => {
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selectedSafra]);

  return (
    <>
      <Row>
        <Col>
          <h4 className="mb-3">
            <Translator path="fazenda.label" />
          </h4>
        </Col>
      </Row>
      <Card>
        <div className="p-3 justify-content-between d-flex align-items-center">
          <Col lg={6}>
            <h6 className="txt-muted">
              <Translator path="fazenda.contador" /> {fazendas.total}
            </h6>
          </Col>
          <Col>
            <Button
              color="muted"
              id="toggler"
              className="d-flex align-items-center"
            >
              <FiFilter size={20} />
              &nbsp;&nbsp;
              <Translator path="fazenda.filtro" />
            </Button>
          </Col>
          <div className="d-flex justify-content-center">
            <Button
              onClick={() => {
                toggleModalCad();
              }}
              type="button"
              className="btn btn-primary ml-3"
              hidden={user?.perfil === 4}
            >
              <Translator path="fazenda.botao.novafazenda" />
            </Button>
          </div>
          <div className="d-flex justify-content-center" />
        </div>
        <div className="filter-collapse px-3 ">
          <UncontrolledCollapse toggler="#toggler" className="pb-3">
            <Row>
              <Col lg={3}>
                <Label>
                  <Translator path="fazenda.filtro.nome" />
                </Label>
                <input
                  onChange={(e) => debounceConsulta(e.target.value, 'nome')}
                  className="form-control"
                />
              </Col>
              <Col lg={3}>
                <Label>
                  <Translator path="fazenda.filtro.responsavel" />
                </Label>
                <input
                  onChange={(e) =>
                    debounceConsulta(e.target.value, 'responsavel')
                  }
                  className="form-control"
                />
              </Col>
            </Row>
          </UncontrolledCollapse>
        </div>

        <Table responsive>
          <thead>
            <tr>
              <th>
                <Translator path="fazenda.grid.name" />
              </th>
              <th>
                <Translator path="fazenda.grid.responsavel" />
              </th>
              <th>
                <Translator path="fazenda.grid.estado" />
              </th>
              <th>
                <Translator path="fazenda.grid.cidade" />
              </th>
              <th>
                <Translator path="fazenda.grid.acao" />
              </th>
            </tr>
          </thead>
          <tbody>
            {fazendas?.fazendas?.length ? (
              fazendas.fazendas?.map((c) => (
                <tr key={c?.id_fazenda || c?.id}>
                  <td data-label="Nome">{c?.nome || c?.Fazenda?.nome}</td>
                  <td data-label="Responsável">
                    {c?.responsavel || c?.Fazenda?.responsavel}
                  </td>
                  <td data-label="Estado">{c?.estado || c?.Fazenda?.estado}</td>
                  <td data-label="Cidade">{c?.cidade || c?.Fazenda?.cidade}</td>
                  <td data-label="Ação" className="text-center">
                    <div>
                      <UncontrolledDropdown
                        size="xs"
                        style={{ position: 'absolute' }}
                      >
                        <DropdownToggle color="link link-gray" size="xs">
                          <FaEllipsisH size="1.3em" color="#43b02a" />
                        </DropdownToggle>
                        <DropdownMenu right>
                          <DropdownItem
                            onClick={() => {
                              carregaSafras(c?.id_fazenda || c?.id);
                            }}
                            size="xs"
                          >
                            <FiMap className="mr-1" size={18} />
                            <Translator path="fazenda.grid.acao.vernomapa" />
                          </DropdownItem>
                          <DropdownItem
                            onClick={() => {
                              toggleModalSafras();
                              setFazendaId(c?.id_fazenda || c?.id);
                            }}
                            size="xs"
                            hidden={
                              user?.perfil === 4 ||
                              user?.perfil === 3 ||
                              user?.perfil === 2
                            }
                          >
                            <GiWheat className="mr-1" size={18} />
                            <Translator path="fazenda.grid.acao.safratalhaocroqui" />
                          </DropdownItem>
                          <DropdownItem
                            onClick={() => {
                              dadosFazenda(c?.id_fazenda || c?.id);
                            }}
                            size="xs"
                            hidden={user?.perfil === 4}
                          >
                            <FiEdit3 className="mr-1" size={18} />
                            <Translator path="fazenda.grid.acao.vereditardados" />
                          </DropdownItem>
                          <hr />
                          <DropdownItem
                            onClick={() => {
                              getUsuariosVinculados(c?.id_fazenda || c?.id);
                            }}
                            size="xs"
                            hidden={user?.perfil === 4 || user?.perfil === 2}
                          >
                            <FiUsers className="mr-1" size={18} />
                            <Translator path="fazenda.grid.acao.usuariosvinculados" />
                          </DropdownItem>
                          <hr />
                          <DropdownItem
                            onClick={() => {
                              uploadDeArquivos(c?.id_fazenda || c?.id);
                            }}
                            size="xs"
                            hidden={
                              user?.perfil === 4 ||
                              user?.perfil === 3 ||
                              user?.perfil === 2
                            }
                          >
                            <FiUpload className="mr-1" size={18} />
                            <Translator path="fazenda.grid.acao.enviararquivos" />
                          </DropdownItem>
                          <hr />
                          <DropdownItem
                            onClick={() => {
                              dowloadShapeFileModal(c?.id_fazenda || c?.id);
                            }}
                            size="xs"
                          >
                            <FiDownload className="mr-1" size={18} />
                            <Translator path="fazenda.grid.acao.baixararquivos" />
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td>
                  <Translator path="semregistros" />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <Pagination
          nextLabel={<FaChevronRight />}
          previousLabel={<FaChevronLeft />}
          pageCount={fazendas.pages || 1}
          onPageChange={({ selected }) =>
            setFiltro({ ...filtro, page: selected + 1 })
          }
          initialPage={0}
          containerClassName="pagination justify-end mr-1"
          activeClassName="active"
        />
      </Card>

      <Modal isOpen={modal} toggle={toggle} size="md">
        <ModalHeader toggle={toggle}>
          <Translator path="fazenda.grid.acao.enviararquivos" />
        </ModalHeader>
        <Form ref={formRef} onSubmit={(data) => handleSubmit(data)}>
          <ModalBody>
            {selectedFazenda && (
              <>
                <Row>
                  <Col lg={12}>
                    <Select
                      label={<Translator path="fazenda.upload.origem" />}
                      className="form-control"
                      name="origem"
                      onChange={(e) => setOrigem(e.target.value)}
                      data={[
                        {
                          label: Translator({
                            path: 'fazenda.upload.selecione',
                          }),
                          value: '',
                        },
                        {
                          id: 'CR',
                          label: Translator({
                            path: 'fazenda.upload.croqui',
                          }),
                          value: 'CR',
                        },
                        {
                          id: 'PCLU',
                          label: Translator({
                            path: 'fazenda.upload.amostragemU',
                          }),
                          value: 'PCLU',
                        },
                        {
                          id: 'PCLL',
                          label: Translator({
                            path: 'fazenda.upload.amostragemS',
                          }),
                          value: 'PCLL',
                        },
                        {
                          id: 'PC',
                          label: Translator({
                            path: 'fazenda.upload.amostragemLU',
                          }),
                          value: 'PC',
                        },
                        {
                          id: 'MF',
                          label: Translator({
                            path: 'fazenda.upload.amostragemMF',
                          }),
                          value: 'MF',
                        },
                        {
                          id: 'MA',
                          label: Translator({
                            path: 'fazenda.upload.amostragemMA',
                          }),
                          value: 'MA',
                        },
                        {
                          id: 'T',
                          label: Translator({
                            path: 'fazenda.upload.talhao',
                          }),
                          value: 'T',
                        },
                        {
                          id: 'CSVA',
                          label: Translator({
                            path: 'fazenda.upload.csva',
                          }),
                          value: 'CSVA',
                        },
                        {
                          id: 'CSVF',
                          label: Translator({
                            path: 'fazenda.upload.csvf',
                          }),
                          value: 'CSVF',
                        },
                      ]}
                    />
                  </Col>
                  {(origem === 'PCLL' || origem === 'PCLU') && (
                    <Col lg={12}>
                      <Select
                        label={<Translator path="fazenda.upload.safra" />}
                        className="form-control"
                        name="safra"
                        data={safrasFazendaUpload}
                      />
                    </Col>
                  )}
                  {origem !== '' &&
                  origem !== 'T' &&
                  origem !== 'PCLL' &&
                  origem !== 'PCLU' ? (
                    <>
                      <Col lg={12}>
                        <Select
                          label={`Safra${origem === 'CR' ? naoSelecione : ''}`}
                          className="form-control"
                          name="safra"
                          data={safrasFazendaUpload}
                          onChange={(e) => {
                            setSelectedSafra(e?.target?.value);
                            getTalhoesSafra(e?.target?.value);
                          }}
                        />
                      </Col>
                      <Col lg={12} hidden={!(selectedSafra && origem !== 'CR')}>
                        <Select
                          label={<Translator path="fazenda.upload.talhao" />}
                          className="form-control adasda"
                          name="talhao"
                          data={talhoesSafra}
                        />
                      </Col>
                    </>
                  ) : (
                    <Col />
                  )}
                  {origem === 'T' && (
                    <>
                      <Col lg={12}>
                        <Input
                          label={<Translator path="fazenda.upload.descricao" />}
                          className="form-control"
                          name="descricao"
                        />
                      </Col>
                    </>
                  )}
                </Row>
                <Row>
                  {origem && (
                    <>
                      <Col>
                        <Input
                          name="file"
                          type="file"
                          accept=".zip, .kml"
                          label={
                            <Translator path="fazenda.upload.arquivotipo" />
                          }
                          onChange={(event) => {
                            event.preventDefault();
                            const file = event.target.files[0];
                            const fileExtension = file?.name?.split('.').pop();

                            const reader = new window.FileReader();
                            if (fileExtension === 'zip') {
                              reader.readAsArrayBuffer(file);
                              reader.onloadend = () => {
                                const buffer = reader.result;

                                shp(buffer).then((geojson) => {
                                  if (geojson.length) {
                                    setGeoJSON(geojson);
                                  } else {
                                    setGeoJSON([geojson]);
                                  }
                                });
                              };
                            } else {
                              reader.readAsText(file);
                              reader.onloadend = (e) => {
                                const kmlFile = new DOMParser().parseFromString(
                                  e.target.result,
                                  'text/xml'
                                );
                                const geoJsonObject = kml(kmlFile);
                                if (geoJsonObject.length) {
                                  setGeoJSON(geoJsonObject);
                                } else {
                                  setGeoJSON([geoJsonObject]);
                                }
                              };
                            }
                          }}
                        />
                      </Col>
                    </>
                  )}
                  {(origem === 'CSVA' || origem === 'CSVF') && (
                    <Col lg={12} md={12} sm={12}>
                      <hr />
                      <label>
                        <Translator path="fazenda.upload.arquivocsv" />
                      </label>
                      <CSVReader
                        parserOptions={{
                          header: false,
                          dynamicTyping: true,
                          skipEmptyLines: true,
                          transformHeader: (header) =>
                            header.toLowerCase().replace(/\W/g, '_'),
                        }}
                        onFileLoaded={(data) => formatCSVData(data)}
                      />
                    </Col>
                  )}
                </Row>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="mapa.assist.adicionar.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modalSafra} toggle={toggleSafra} size="lg">
        <ModalHeader toggle={toggleSafra}>
          <Translator path="fazenda.safratalhoescroqui.safras.novasafra.label" />
        </ModalHeader>
        <Form ref={formRefSafra} onSubmit={(data) => handleSubmitSafra(data)}>
          <ModalBody>
            {selectedFazenda && (
              <>
                <Row>
                  <Col lg={12}>
                    <Input
                      name="descricao"
                      label={
                        <Translator path="fazenda.safratalhoescroqui.safras.novasafra.label" />
                      }
                      className="form-control"
                      type="text"
                    />
                  </Col>
                  {/* <Col lg={6}>
                    <ReactSelectAsyncCreatable
                      label="Cultura"
                      name="id_cultura"
                      isClearable
                      loadOptions={optionsCulturas}
                      onCreateOption={handleAddCultura}
                    />
                  </Col> */}
                </Row>
                {/* <Row>
                  <Col lg={12}>
                    <ReactSelect
                      label="Talhões"
                      name="ids_talhoes"
                      isMulti
                      isClearable
                      options={safrasFazenda}
                    />
                  </Col>
                </Row> */}
                <Row>
                  <Col lg={6}>
                    <Input
                      name="data_inicio"
                      label={
                        <Translator path="fazenda.safratalhoescroqui.safras.novasafra.datainicio" />
                      }
                      className="form-control"
                      type="date"
                    />
                  </Col>
                  <Col lg={6}>
                    <Input
                      name="data_termino"
                      label={
                        <Translator path="fazenda.safratalhoescroqui.safras.novasafra.datatermino" />
                      }
                      className="form-control"
                      type="date"
                    />
                  </Col>
                </Row>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="botao.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modalSafrafazenda} toggle={toggleSafrasFazenda} size="md">
        <ModalHeader toggle={toggleSafrasFazenda}>
          <Translator path="fazenda.mapa.safra" />
        </ModalHeader>

        <ModalBody>
          {safrasFazenda && (
            <>
              <Table responsive>
                <tbody>
                  {safrasFazenda?.length ? (
                    safrasFazenda?.map((c) => (
                      <tr key={c?.id}>
                        <td
                          className="text-center"
                          style={{ paddingTop: '10px' }}
                        >
                          {c?.descricao}
                        </td>
                        <td className="text-center w-25">
                          <Link
                            // eslint-disable-next-line prefer-template
                            to={'/mapa/' + fazendaId + '/' + c.id}
                            className="btn-sm btn btn-outline-info btn-block"
                          >
                            <FaLocationArrow />
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td>
                        <Translator path="semregistros" />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </>
          )}
        </ModalBody>
      </Modal>

      <Modal isOpen={modalCad} toggle={toggleModalCad} size="lg">
        <ModalHeader toggle={toggleModalCad}>
          <Translator path="fazenda.novafazenda.label" />
        </ModalHeader>
        <Form ref={formRefFazenda} onSubmit={(data) => handleCadFazenda(data)}>
          <ModalBody>
            {selectedFazenda && (
              <>
                <Row>
                  <Col lg={6}>
                    <Input
                      name="nome"
                      label={
                        <Translator path="fazenda.novafazenda.nomefazenda" />
                      }
                      className="form-control"
                      type="text"
                    />
                  </Col>
                  <Col lg={6}>
                    <ReactSelectAsync
                      label={<Translator path="fazenda.novafazenda.produtor" />}
                      name="id_produtor"
                      isClearable
                      loadOptions={optionsProdutor}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <Input
                      name="responsavel"
                      label={
                        <Translator path="fazenda.novafazenda.nomeresponsavel" />
                      }
                      className="form-control"
                      type="text"
                    />
                  </Col>
                  <Col lg={6}>
                    <Select
                      label={
                        <Translator path="fazenda.novafazenda.tipodocumento" />
                      }
                      className="form-control"
                      name="tipo_documento"
                      data={[
                        {
                          label: Translator({
                            path: 'fazenda.upload.selecione',
                          }),
                          value: '',
                        },
                        {
                          label: 'RG',
                          value: 'rg',
                        },
                        {
                          label: 'CNH',
                          value: 'cnh',
                        },
                        {
                          label: 'RNM',
                          value: 'rnm',
                        },
                        {
                          label: Translator({
                            path: 'outros',
                          }),
                          value: 'outros',
                        },
                      ]}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <Input
                      name="documento"
                      label={
                        <Translator path="fazenda.novafazenda.numerodocumento" />
                      }
                      className="form-control"
                      type="text"
                    />
                  </Col>
                  <Col lg={6}>
                    <Input
                      name="contato"
                      label={
                        <Translator path="fazenda.novafazenda.nomecontato" />
                      }
                      className="form-control"
                      type="text"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <Input
                      name="email"
                      label={<Translator path="fazenda.novafazenda.email" />}
                      className="form-control"
                      type="text"
                    />
                  </Col>
                  <Col lg={6}>
                    <Input
                      name="telefone"
                      label={<Translator path="fazenda.novafazenda.telefone" />}
                      className="form-control"
                      type="text"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={3}>
                    <Input
                      name="cep"
                      label={<Translator path="fazenda.novafazenda.cep" />}
                      className="form-control"
                      onBlur={(e) => {
                        consultarCep(e.target.value);
                      }}
                      type="text"
                    />
                  </Col>
                  <Col lg={6}>
                    <Input
                      name="logradouro"
                      label={
                        <Translator path="fazenda.novafazenda.logradouro" />
                      }
                      className="form-control"
                      type="text"
                    />
                  </Col>
                  <Col lg={3}>
                    <Input
                      name="numero"
                      label={<Translator path="fazenda.novafazenda.numero" />}
                      className="form-control"
                      type="number"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={4}>
                    <Input
                      name="bairro"
                      label={<Translator path="fazenda.novafazenda.bairro" />}
                      className="form-control"
                      type="text"
                    />
                  </Col>
                  <Col lg={4}>
                    <Input
                      name="estado"
                      label={<Translator path="fazenda.novafazenda.estado" />}
                      className="form-control"
                      type="text"
                    />
                  </Col>
                  <Col lg={4}>
                    <Input
                      name="cidade"
                      label={<Translator path="fazenda.novafazenda.cidade" />}
                      className="form-control"
                      type="text"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <Input
                      name="complemento"
                      label={
                        <Translator path="fazenda.novafazenda.complemento" />
                      }
                      className="form-control"
                      type="text"
                    />
                  </Col>
                </Row>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="fazenda.novafazenda.btnsalvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal
        isOpen={modalSafraDowloadSHP}
        toggle={toggleSafraDowloadSHP}
        size="sm"
        onClosed={() => setTipoDowload('CR')}
      >
        <ModalHeader toggle={toggleSafraDowloadSHP}>
          <Translator path="fazenda.downloadarquivos.label" />
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <select
                name="select"
                className="form-control"
                onChange={(e) => setTipoDowload(e?.target?.value)}
              >
                <option value="CR" selected>
                  {croqui}
                </option>
                <option value="MA">{mapaaplicacao}</option>
                <option value="MF">{mapafertilidade}</option>
                <option value="PC">{pontos}</option>
              </select>
            </Col>
          </Row>
          <p className="mt-4 justify-center">
            <Translator path="fazenda.downloadarquivos.safra" />
          </p>
          {safrasFazenda && (
            <>
              <Table responsive>
                <tbody>
                  {safrasFazenda?.length ? (
                    safrasFazenda?.map((c) => (
                      <tr key={c?.id}>
                        <td
                          className="text-center"
                          style={{ paddingTop: '10px' }}
                        >
                          {c?.descricao}
                        </td>
                        <td className="text-center">
                          {/* {tipoDowload !== 'CR' ? (
                            <>
                              {tipoDowload === 'PC' ? (
                                <Button
                                  onClick={() => getTalhoesSafraID(c.id)}
                                  className="btn-sm"
                                  outline
                                  color="info"
                                  block
                                >
                                  <FaArrowDown />
                                </Button>
                              ) : (
                                <Button
                                  onClick={() =>
                                    getArquivosDowload(c.id, tipoDowload)
                                  }
                                  className="btn-sm"
                                  outline
                                  color="info"
                                  block
                                >
                                  <FaArrowDown />
                                </Button>
                              )}
                            </>
                          ) : (
                            <Button
                              onClick={() => dowloadShapeFile(fazendaId, c.id)}
                              className="btn-sm"
                              outline
                              color="info"
                              block
                            >
                              <FaDownload />
                            </Button>
                          )} */}

                          <Button
                            onClick={() =>
                              getArquivosDowload(c.id, tipoDowload)
                            }
                            className="btn-sm"
                            outline
                            color="info"
                            block
                          >
                            <FaArrowDown />
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td>
                        <Translator path="excecoes.semregistros" />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </>
          )}
        </ModalBody>
      </Modal>

      <Modal isOpen={modalTalhoes} toggle={toggleSelectTalhoes} size="sm">
        <ModalHeader toggle={toggleSelectTalhoes}>
          <Translator path="fazenda.selecionetalhao" />
        </ModalHeader>

        <Form
          ref={formRefTalhoesDownload}
          onSubmit={(data) => handleDownload(data)}
        >
          <ModalBody>
            <Row>
              <Col>
                <p />
                {talhoesSafra?.length ? (
                  <Select
                    label={<Translator path="fazenda.upload.talhao" />}
                    className="form-control"
                    name="talhao"
                    data={talhoesSafra}
                  />
                ) : (
                  <p>
                    <Translator path="fazenda.semtalhoes" />
                  </p>
                )}
              </Col>
            </Row>
          </ModalBody>
          {talhoesSafra?.length && (
            <ModalFooter>
              <Button color="success" type="submit">
                Download
              </Button>
            </ModalFooter>
          )}
        </Form>
      </Modal>

      <Modal isOpen={modalSafras} toggle={toggleModalSafras} size="xl">
        <ModalHeader toggle={toggleModalSafras}>
          <Translator path="fazenda.safratalhoescroqui.label" />
        </ModalHeader>
        <ModalBody>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={activeTab === '1' ? 'active' : ''}
                onClick={() => {
                  toggleTab('1');
                }}
              >
                <Translator path="fazenda.safras" />
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === '2' ? 'active' : ''}
                onClick={() => {
                  toggleTab('2');
                }}
              >
                <Translator path="fazenda.safratalhoescroqui.safras.editarsafra.talhoes" />
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === '3' ? 'active' : ''}
                onClick={() => {
                  toggleTab('3');
                }}
              >
                <Translator path="mapa.menu.croqui" />
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Safras idFazenda={fazendaId} />
            </TabPane>
            <TabPane tabId="2">
              <Talhoes idFazenda={fazendaId} />
            </TabPane>
            <TabPane tabId="3">
              <Croquis idFazenda={fazendaId} />
            </TabPane>
          </TabContent>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalDados} toggle={toggleModalDados} size="xl">
        <ModalHeader toggle={toggleModalDados}>
          <Translator path="fazenda.vereditardados.label" />
        </ModalHeader>
        <Form ref={formRefFazenda} onSubmit={(data) => handleEditFazenda(data)}>
          <ModalBody>
            <Row>
              <Col lg={6}>
                <Input
                  name="nome"
                  label={
                    <Translator path="fazenda.vereditardados.nomefazenda" />
                  }
                  className="form-control"
                  type="text"
                  defaultValue={fazendaData?.fazenda?.nome}
                />
              </Col>
              <Col lg={6}>
                <ReactSelectAsync
                  label={<Translator path="fazenda.vereditardados.produtor" />}
                  name="id_produtor"
                  isClearable
                  loadOptions={optionsProdutor}
                  defaultValue={{
                    id: fazendaData?.fazenda?.Produtor?.id,
                    label: fazendaData?.fazenda?.Produtor?.nome,
                    value: fazendaData?.fazenda?.Produtor?.id,
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Input
                  name="responsavel"
                  label={
                    <Translator path="fazenda.vereditardados.nomeresponsavel" />
                  }
                  className="form-control"
                  type="text"
                  defaultValue={fazendaData?.fazenda?.responsavel}
                />
              </Col>
              <Col lg={6}>
                <Select
                  label={
                    <Translator path="fazenda.vereditardados.tipodocumento" />
                  }
                  className="form-control"
                  name="tipo_documento"
                  defaultValue={fazendaData?.fazenda?.tipo_documento}
                  data={[
                    {
                      label: Translator({
                        path: 'fazenda.upload.selecione',
                      }),
                      value: '',
                    },
                    {
                      id: 'rg',
                      label: 'RG',
                      value: 'rg',
                    },
                    {
                      id: 'cnh',
                      label: 'CNH',
                      value: 'cnh',
                    },
                    {
                      id: 'rnm',
                      label: 'RNM',
                      value: 'rnm',
                    },
                    {
                      id: 'outros',
                      label: Translator({
                        path: 'outros',
                      }),
                      value: 'outros',
                    },
                  ]}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Input
                  name="documento"
                  label={
                    <Translator path="fazenda.novafazenda.numerodocumento" />
                  }
                  className="form-control"
                  type="text"
                  defaultValue={fazendaData?.fazenda?.documento}
                />
              </Col>
              <Col lg={6}>
                <Input
                  name="contato"
                  label={<Translator path="fazenda.novafazenda.nomecontato" />}
                  className="form-control"
                  type="text"
                  defaultValue={fazendaData?.fazenda?.contato}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Input
                  name="email"
                  label={<Translator path="fazenda.novafazenda.email" />}
                  className="form-control"
                  type="text"
                  defaultValue={fazendaData?.fazenda?.email}
                />
              </Col>
              <Col lg={6}>
                <Input
                  name="telefone"
                  label={<Translator path="fazenda.novafazenda.telefone" />}
                  className="form-control"
                  type="text"
                  defaultValue={fazendaData?.fazenda?.telefone}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={3}>
                <Input
                  name="cep"
                  label={<Translator path="fazenda.novafazenda.cep" />}
                  className="form-control"
                  onBlur={(e) => {
                    consultarCep(e.target.value);
                  }}
                  type="text"
                  defaultValue={fazendaData?.fazenda?.cep}
                />
              </Col>
              <Col lg={6}>
                <Input
                  name="logradouro"
                  label={<Translator path="fazenda.novafazenda.logradouro" />}
                  className="form-control"
                  type="text"
                  defaultValue={fazendaData?.fazenda?.logradouro}
                />
              </Col>
              <Col lg={3}>
                <Input
                  name="numero"
                  label={<Translator path="fazenda.novafazenda.numero" />}
                  className="form-control"
                  type="number"
                  defaultValue={fazendaData?.fazenda?.numero}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <Input
                  name="bairro"
                  label={<Translator path="fazenda.novafazenda.bairro" />}
                  className="form-control"
                  type="text"
                  defaultValue={fazendaData?.fazenda?.bairro}
                />
              </Col>
              <Col lg={4}>
                <Input
                  name="estado"
                  label={<Translator path="fazenda.novafazenda.estado" />}
                  className="form-control"
                  type="text"
                  defaultValue={fazendaData?.fazenda?.estado}
                />
              </Col>
              <Col lg={4}>
                <Input
                  name="cidade"
                  label={<Translator path="fazenda.novafazenda.cidade" />}
                  className="form-control"
                  type="text"
                  defaultValue={fazendaData?.fazenda?.cidade}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <Input
                  name="complemento"
                  label={<Translator path="fazenda.novafazenda.complemento" />}
                  className="form-control"
                  type="text"
                  defaultValue={fazendaData?.fazenda?.complemento}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="fazenda.novafazenda.btnsalvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modalUsuarios} toggle={toggleModalUsuarios} size="lg">
        <ModalHeader toggle={toggleModalUsuarios}>
          <Translator path="fazenda.usuariosvinculados.label" />
        </ModalHeader>

        <ModalBody>
          <Table responsive>
            <thead>
              <tr>
                <th className="text-center">
                  <Translator path="fazenda.usuariosvinculados.nome" />
                </th>
                <th className="text-center">
                  <Translator path="fazenda.usuariosvinculados.email" />
                </th>
                <th className="text-center">
                  <Translator path="fazenda.usuariosvinculados.perfil" />
                </th>
              </tr>
            </thead>
            <tbody>
              {usuariosFazenda?.length ? (
                usuariosFazenda?.map((c) => (
                  <tr key={c?.id}>
                    <td className="text-center" style={{ paddingTop: '10px' }}>
                      {c?.Usuario?.nome}
                    </td>
                    <td className="text-center" style={{ paddingTop: '10px' }}>
                      {c?.Usuario?.email}
                    </td>
                    <td className="text-center" style={{ paddingTop: '10px' }}>
                      {c?.Usuario?.Perfil?.tipo}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>
                    <Translator path="excecoes.semregistros" />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalImport} toggle={toggleImport} size="lg">
        <ModalHeader toggle={toggleImport}>
          <Translator path="fazenda.safratalhoescroqui.safras.verinfotalhoes.label" />
        </ModalHeader>
        <Form>
          <ModalBody style={{ maxHeight: 500, overflowY: 'auto' }}>
            <Table responsive>
              <thead>
                <tr>
                  <th className="text-center">
                    <Translator path="fazenda.upload.descricao" />
                  </th>
                  <th className="text-center">
                    <Translator path="fazenda.ativetalhoes.area" />
                  </th>
                  <th className="text-center">
                    <Translator path="fazenda.ativetalhoes.status" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {talhoesImportCR?.length ? (
                  talhoesImportCR?.map((c) => (
                    <tr key={c?.id}>
                      <td
                        className="text-center"
                        style={{ paddingTop: '10px' }}
                      >
                        {c?.descricao}
                      </td>
                      <td
                        className="text-center"
                        style={{ paddingTop: '10px' }}
                      >
                        {c?.area} h
                      </td>
                      <td className="text-center">
                        <Select
                          label=""
                          className="form-control"
                          name="tipo_documento"
                          defaultValue={c?.status}
                          onChange={(e) => {
                            statusTalhaoSafra(
                              c?.id,
                              c?.id_fazenda,
                              e?.target?.value
                            );
                          }}
                          data={[
                            {
                              id: 'I',
                              label: inativo,
                              value: 'I',
                            },
                            {
                              id: 'A',
                              label: ativo,
                              value: 'A',
                            },
                          ]}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>
                      <Translator path="excecoes.semregistros" />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </ModalBody>
        </Form>
        <ModalFooter>
          <Button onClick={toggleImport} color="success" type="button">
            Ok
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={modalArquivosDowload}
        toggle={toggleModalArquivosDownload}
        size="lg"
      >
        <ModalHeader toggle={toggleModalArquivosDownload}>
          <Translator path="dowload.novo.header" />
        </ModalHeader>
        <Form>
          <ModalBody style={{ maxHeight: 500, overflowY: 'auto' }}>
            <Table responsive>
              <thead>
                <tr>
                  <th className="text-center">
                    <Translator path="dowload.novo.nomeArquivo" />
                  </th>
                  <th className="text-center">
                    <Translator path="dowload.novo.talhao" />
                  </th>
                  <th className="text-center">
                    <Translator path="dowload.novo.acao" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {arquivosDownload?.length ? (
                  arquivosDownload?.map((c) => (
                    <tr key={c?.id}>
                      <td
                        className="text-center"
                        style={{ paddingTop: '10px' }}
                      >
                        {c?.nome_arquivo}
                      </td>
                      <td
                        className="text-center"
                        style={{ paddingTop: '10px' }}
                      >
                        {c?.Talhao?.descricao || 'N/A'}
                      </td>
                      <td className="text-center">
                        <Button onClick={() => openInNewTab(c?.path)}>
                          <FaDownload />
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>
                      <Translator path="excecoes.semregistros" />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </ModalBody>
        </Form>
        <ModalFooter>
          <Button
            onClick={toggleModalArquivosDownload}
            color="success"
            type="button"
          >
            Ok
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default Fazendas;
